import { ContentLanguageLabelModel } from '@fi-shared/models';

export class DataFieldPreSetOptionModel {
    constructor(data?: DataFieldPreSetOptionModel) {
        if (data) this.initData(data);
    }

    Id: number = 0;
    Names: Array<ContentLanguageLabelModel> = [];
    Name: string;

    initData(data: DataFieldPreSetOptionModel) {
        this.Id = data.Id;
        this.Name = data.Name;
        if (data.Names)
            this.Names = data.Names.map(
                (name) => new ContentLanguageLabelModel(name.ContentLanguageId, name.Value, name.SortIndex),
            );
    }
}
